export default __webpack_public_path__ + "static/media/right_featured.610fd591.jpg";